import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Hero from "./components/Hero";
import Bio from "./components/Bio";
import Members from "./components/Members";
import Archive from "./components/Archive";
import Gallery from "./components/Gallery";
import VideoSection from "./components/VideoSection";
import Footer from "./components/Footer";
import ContactsDialog from "./components/ContactsDialog";

const Home = () => {
  const [contactsOpen, setContactsOpen] = useState(false);

  return (
    <div className="bg-[#050505] text-white min-h-screen" data-testid="home-page">
      <Hero onOpenContacts={() => setContactsOpen(true)} />
      <Bio />
      <Members />
      <Archive />
      <Gallery />
      <VideoSection />
      <Footer onOpenContacts={() => setContactsOpen(true)} />
      <ContactsDialog open={contactsOpen} onOpenChange={setContactsOpen} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
